<ps-icon-inner [inlineSVG]="rootUrl + '/assets/icons/' + name + '.svg'"></ps-icon-inner>
